module.exports = __webpack_public_path__ + "static/media/theater-02.5a06b548.jpg";